import styles from '@/styles/topReview/categoryFilter.module.scss'
import Link from 'next/link'
import { MenuOutlined } from '@ant-design/icons'
import GoogleADSense from "@/components/GoogleADSense"

import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const apiDomain = publicRuntimeConfig.apiDomain

interface Props {
  categoryId: number | string;
  showAdvertise?: boolean;
}

export default function TopReviewCategoryFilter({ categoryId, showAdvertise }: Props) {
  interface categoryItem {
    name: string;
    icon: string;
    link: string;
    linkName?: string;
    categoryId: number;
  }

  let categoryData: categoryItem[] = [
    { name: 'Holiday Deals', icon: 'csicon-category-2975', link: '/holiday-deals', categoryId: 2975 },
    { name: 'Appliances', icon: 'csicon-category-2107', link: '/appliances', categoryId: 2107 },
    { name: 'Furniture', icon: 'csicon-category-57', link: '/furniture', categoryId: 57 },
    { name: 'Home & Garden', icon: 'csicon-category-147', link: '/home-garden', categoryId: 147 },
    { name: 'Sports & Fitness', icon: 'csicon-category-4', link: '/sports-fitness', categoryId: 4 },
    { name: 'Pet Supplies', icon: 'csicon-category-73', link: '/pet-supplies', categoryId: 73 },
    { name: 'Outdoor & Leisure', icon: 'csicon-category-334', link: '/outdoor-leisure', categoryId: 334 },
    { name: 'Baby, Kids & Toys', icon: 'csicon-category-2959', link: '/baby-kids-toys', categoryId: 2959 },
    { name: 'Bedding & Bath', icon: 'csicon-category-258', link: '/bedding-bath', categoryId: 258 },
    { name: 'Health & Beauty', icon: 'csicon-category-62', link: '/health-beauty', categoryId: 62 },
    { name: 'Tools & Auto', icon: 'csicon-category-2957', link: '/tools-auto', categoryId: 2957 },
    { name: 'Electronics', icon: 'csicon-category-50', link: '/electronics', categoryId: 50 },
    { name: 'Novelties & Gifts', icon: 'csicon-category-65', link: '/novelties-gifts', categoryId: 65 },
    { name: 'Musical Instruments', icon: 'csicon-category-35', link: '/musical-instruments', categoryId: 35 },
    { name: 'Jewellery', icon: 'csicon-category-991', link: '/jewellery', categoryId: 991 },
    { name: 'LED Lights', icon: 'csicon-category-3781', link: '/led-lights', categoryId: 3781 },
    { name: 'Fashion & Bags', icon: 'csicon-category-109', link: '/fashion-bags', categoryId: 109 },
    { name: 'Computers & IT', icon: 'csicon-category-70', link: '/computers-it', categoryId: 70 }
  ]
  // 格式化分类数据
  categoryData.forEach((item: any) => {
    // 转换为小写
    const lowerCaseName = item.name.toLowerCase();
    // 替换符号和空格为-
    const linkName = lowerCaseName.replace(/[\s&,]+/g, '-');
    // 移除连续的-
    item.linkName = linkName.replace(/-+/g, '-');
  })

  return (
    <>
      <div className={styles['comp-category-filter']}>
        <div className={styles['title-box']}>
          <MenuOutlined className={styles['icon-menu']}></MenuOutlined>
          Browse
        </div>

        {/* 遍历分类 */}
        {
          categoryData.map((item: categoryItem) => (
            <Link
              key={item.categoryId}
              href={`${apiDomain}/top-reviewed-${item.linkName}-${item.categoryId}-1`}
              passHref
              legacyBehavior
            >
              <a
                className={`
                  ${styles['category-item']}
                  ${categoryId == item.categoryId ? styles['active'] : ''}
                `}
                rel="noopener noreferrer"
              >
                {item.name}
              </a>
            </Link>
          ))
        }
        
        <div style={{ marginTop: '20px' }}>
          <GoogleADSense />
        </div>
      </div>
    </>
  )
}